module.exports = __webpack_public_path__ + "static/media/Neuropol-X-Rg.e42ada49.ttf";